import { SideSectionDetails } from './side-section-details';
import { SideSectionWorkUnits } from './side-section-work-units';
import { SideSectionTab } from './side-section.type';

type Props = {
  activeTab: SideSectionTab;
};

export const SideSectionContent = ({ activeTab }: Props) => {
  switch (activeTab) {
    case SideSectionTab.Details:
      return <SideSectionDetails />;
    case SideSectionTab.WorkUnits:
      return <SideSectionWorkUnits />;
    default:
      return null;
  }
};
